import { ChevronDown } from "lucide-react";
import { CopyButton } from "./CopyButton";

export function RawDetails({
  label,
  value,
}: {
  label: string;
  value: unknown;
}) {
  if (value === undefined) return null;
  return (
    <details className="group min-w-0 flex-1 rounded-lg border border-stone-200 dark:border-white/10">
      <summary className="flex cursor-pointer list-none items-center gap-2 px-2.5 py-2 text-[11px] font-semibold text-stone-500 marker:content-none dark:text-stone-400">
        <ChevronDown size={13} className="transition group-open:rotate-180" />{" "}
        {label}
      </summary>
      <div className="border-t border-stone-200 dark:border-white/10">
        <div className="flex justify-end px-1 pt-1">
          <CopyButton value={value} />
        </div>
        <pre className="max-h-52 overflow-auto bg-stone-100/70 p-2.5 font-mono text-[11px] leading-4 text-stone-600 dark:bg-black/20 dark:text-stone-300">
          {JSON.stringify(value, null, 2)}
        </pre>
      </div>
    </details>
  );
}
